import modalMixin from '../../mixins/_modal';

/**
 * 振込先口座の編集モーダル画面
 */
export default {
    name: 'PayMessageEditer',
    template: '#pay_message_editer_template',
    data() {
        return {
            key: '',
            message: '',
        };
    },
    mixins: [
        modalMixin
    ],
    emits: ['update-pay-message'],
    methods: {
        show: function (key, message) {
            this.key = key;
            this.message = message;
            this.open();
        },
        // 編集を保存する
        save: function (event) {
            // HTML5のバリデーションエラーの場合はそのままフォーム送信する
            if (!event.target.form.checkValidity()) {
                return;
            }
            event.preventDefault();
            this.emitUpdatePayMessage();
            this.close();
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集データを通知
        emitUpdatePayMessage: function() {
            this.$emit('update-pay-message', this.key, this.message);
        }
    }
};